import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta16ExemplosEnum,
  ConsultaSeguimentoPergunta16Model,
} from './model-consultaSeguimentoPergunta16'

const pergunta16ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta16ExemplosEnum)

export function isPergunta16ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta16ExemplosEnumValues)
}

export function isPergunta16ExemplosAllNao(value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta16ExemplosEnumValues)
}

export function hasPergunta16ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta16ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}
